import { InputLabel } from '@material-ui/core';
import cx from 'classnames';
import React from 'react';

import { QuestionLayout } from '../../components/QuestionLayout/QuestionLayout';
import { Typography } from '../../components/Typography';
import { QuestionWithMedia } from './QuestionWithMedia';
import { useStyles } from './styles';

export interface QuestionProps {
  hint?: React.ReactNode;
  question: string;
  id: string;
  required?: boolean;
  dense?: boolean;
  isReachApplicationFormEnabled?: boolean;
  imageUrl?: string | null;
  children?: React.ReactNode;
}

export const Question: React.FC<QuestionProps> = ({
  id,
  hint,
  question,
  children,
  required,
  dense,
  imageUrl,
}) => {
  const styles = useStyles();

  if (imageUrl) {
    return (
      <QuestionWithMedia
        id={id}
        hint={hint}
        question={question}
        required={required}
        dense={dense}
        imageUrl={imageUrl}
      >
        {children}
      </QuestionWithMedia>
    );
  }

  return (
    <QuestionLayout
      input={children}
      question={
        <InputLabel htmlFor={id}>
          <Typography
            {...(!dense && { variant: 'headingMD' })}
            className={cx(styles.questionText, {
              [styles.required]: required,
            })}
          >
            {question}
          </Typography>
        </InputLabel>
      }
      hint={hint}
      dense={dense}
    />
  );
};
